<template>
  <b-modal
    id="modalCreateCalculationProductionWriteFinePremium"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onOpenModal"
    @close="localActive = false"
  >
    <div class="m-write-fine-premium">
      <svg
        class="m-write-fine-premium-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-write-fine-premium-title">
        {{ calculationType === "byPeriod" ? "Выписать штраф/премию" : "Выписать штраф/премию смене" }}
      </div>
      <div class="m-write-fine-premium-form">
        <div class="m-write-fine-premium-form-row">
          <c-input
            v-model="categoryLocalValue"
            class="m-write-fine-premium-form-row-category"
            type="select"
            placeholder="Все"
            label="Производство"
            :items="categoryLocalItems"
          />
          <c-switcher
            v-model="switcherLocalValue"
            class="m-write-fine-premium-form-row-switcher"
            :class="{
              'm-write-fine-premium-form-row-switcher-red': switcherLocalValue === 'fine',
              'm-write-fine-premium-form-row-switcher-green': switcherLocalValue === 'premium',
            }"
            type="group"
            :items="[
              { label: 'Штраф', value: 'fine' },
              { label: 'Премия', value: 'premium' },
            ]"
          />
        </div>
        <c-select
          v-model="basisLocalValue"
          class="m-write-fine-premium-form-basis-of-fine"
          :class="{ 'm-write-fine-premium-form-basis-of-fine-required': basisErrorMessage.length > 0 }"
          type="select"
          :label="switcherLocalValue === 'fine' ? 'Основание штрафа' : 'Основание премии'"
          :searchable="true"
          :items="basisLocalItems"
          :groups="basisLocalGroups"
          :placeholder="switcherLocalValue === 'fine' ? 'Выберите основание штрафа' : 'Выберите основание премии'"
          :required="basisErrorMessage"
          @input="setDefaultFineValue"

        />
        <div
          class="m-write-fine-premium-form-row-2"
          :class="{ 'm-write-fine-premium-form-row-2-required': amountErrorMessage.length > 0 }"
        >
          <c-input
            v-model="authorLocalValue"
            class="m-write-fine-premium-form-row-2-fine-author"
            type="select"
            :clearable="true"
            :searchable="true"
            placeholder="Все"
            :label="switcherLocalValue === 'fine' ? 'Автор штрафа' : 'Автор премии'"
            :items="authorLocalItems"
          />
          <c-input
            v-model="amountLocalValue"
            class="m-write-fine-premium-form-row-2-amount"
            :class="{ 'm-write-fine-premium-form-row-2-amount-required': amountErrorMessage.length > 0 }"
            type="integer-number"
            placeholder="0"
            label="Сумма, ฿"
            :input-text-condition="amountErrorMessage"
          />
        </div>
      <!--  <c-input
          v-model="commentLocalValue"
          class="m-write-fine-premium-form-comment"
          type="textarea"
          :textarea-max-length="500"
          :clearable="true"
          placeholder="Комментарий"
        />-->
      </div>
      <div class="m-write-fine-premium-actions">
        <c-button size="large" class="m-write-fine-premium-actions-cancel" label="Отменить" @click="cancel" />
        <c-button
          class="m-write-fine-premium-actions-save"
          label="Сохранить"
          color="blue"
          size="large"
          @click="submitForm"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls/button";
import Switcher from "@/components/controls/switcher";
import Select from "@/components/controls2/Select";

export default {
  name: "m-write-fine-premium",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-switcher": Switcher,
    "c-select": Select,
  },

  props: ["active", "tableRecords", "calcData", "isDeliveryTab", "calculationType"],

  data() {
    return {
      localActive: false,
      categoryLocalValue: null,
      categoryLocalItems: [
        { label: "Производство", value: "production" },
        { label: "Доставка", value: "delivery" },
      ],
      switcherLocalValue: "premium",
      basisLocalValue: null,
      basisLocalGroups: [],
      basisLocalItems: [],
      basisErrorMessage: "",
      authorLocalValue: null,
      authorLocalItems: [],
      amountLocalValue: "",
      amountErrorMessage: "",
      commentLocalValue: "",
      submitAttempt: false,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.basisLocalValue = null;
          this.basisLocalGroups = [];
          this.basisLocalItems = [];
          this.basisErrorMessage = "";
          this.authorLocalValue = null;
          this.authorLocalItems = [];
          this.amountLocalValue = "";
          this.amountErrorMessage = "";
          this.commentLocalValue = "";
          this.submitAttempt = false;

          if (this.$route.name === "save-calculation-production") {
            const [firstCategory] = this.categoryLocalItems;
            this.categoryLocalValue = firstCategory;
          } else {
            const [, secondCategory] = this.categoryLocalItems;
            this.categoryLocalValue = secondCategory;
          }
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    basisLocalValue(value) {
      if (this.submitAttempt) {
        if (value === null) {
          this.basisErrorMessage = "Обязательное поле";
        } else {
          this.basisErrorMessage = "";
        }
      }
    },
    amountLocalValue(value) {
      if (this.submitAttempt) {
        if (value === "" || value === null) {
          this.amountErrorMessage = "Обязательное поле";
        } else {
          this.amountErrorMessage = "";
        }
      }
    },
    switcherLocalValue(value) {
      this.basisLocalValue = null;
      this.getBasisValues(value);
    },
  },

  mounted() {
    if (this.$route.name === "save-calculation-production") {
      const [firstCategory] = this.categoryLocalItems;
      this.categoryLocalValue = firstCategory;
    } else {
      const [, secondCategory] = this.categoryLocalItems;
      this.categoryLocalValue = secondCategory;
    }
  },

  methods: {
    setDefaultFineValue() {
      if (!this.basisLocalValue) return;
      this.amountLocalValue = '';
      this.$store
        .dispatch("calculations/getFineInfoForWorker", {
         // workerId: this.record.id,
          reasonId: this.basisLocalValue.value,
          type: this.switcherLocalValue
        })
        .then((res) => {
          if (res !== -1) this.amountLocalValue = res;
        });
    },    
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    cancel() {
      this.localActive = false;
    },
    getBasisValues(switcherValue) {
      this.basisLocalItems = [];
      this.basisLocalGroups = [];
      const postCodesInTable = [];

      if (switcherValue === "fine") {
        Object.entries(this.calcData.fines).forEach(([groupName, groupItems]) => {
          this.basisLocalGroups.push({ name: groupName, label: groupName });
          Object.entries(groupItems).forEach(([itemKey, item]) => {
            if (postCodesInTable.every((post) => item.posts.includes(post))) {
              this.basisLocalItems.push({ label: item.description, value: itemKey, group: groupName });
            }
          });
        });
      } else {
        console.log('!!!!!', this.calcData.bonuses) 
        Object.entries(this.calcData.bonuses).forEach(([groupName, groupItems]) => {
          this.basisLocalGroups.push({ name: groupName, label: groupName });
          Object.entries(groupItems).forEach(([itemKey, item]) => {
            if (postCodesInTable.every((post) => item.posts.includes(post)) || item.posts.length==0) {
              this.basisLocalItems.push({ label: item.description, value: itemKey, group: groupName });
            }
          });
        });
      }
    },

    onOpenModal() {
      const currentUserId = this.$store.state.userId;
      this.authorLocalItems = [];
      this.$store.dispatch("personalEmployee/getWorkersList", currentUserId).then((res) => {
        res.response.forEach((item) => {
          if (!item.is_user) this.authorLocalItems.push({ value: item.id, label: item.name, isUser: item.is_user });
        });
      });

      this.getBasisValues(this.switcherLocalValue);
    },
    submitForm() {
      let isValidForm = true;
      //return 5;
      if (this.basisLocalValue === null) {
        isValidForm = false;
        this.submitAttempt = true;
        this.basisErrorMessage = "Обязательное поле";
      }

      if (this.amountLocalValue === null || this.amountLocalValue === "") {
        isValidForm = false;
        this.submitAttempt = true;
        this.amountErrorMessage = "Обязательное поле";
      }

      if (isValidForm) {
        this.cancel();
        this.$emit("writeFineBonusAllWorkers", {
          type: this.switcherLocalValue,
          author: this.authorLocalValue,
          basis: this.basisLocalValue,
          amount: this.amountLocalValue,
          comment: this.commentLocalValue,
          category: this.categoryLocalValue
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-write-fine-premium {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-form {
    &-row {
      margin-top: 18px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-category {
        width: calc(100% - 200px);
        max-width: calc(100% - 200px);

        @media screen and (max-width: 700px) {
          width: 100%;
          max-width: 100%;
        }
      }

      &-switcher {
        max-width: 170px;

        @media screen and (max-width: 700px) {
          margin-top: 27px;
          width: 100%;
          max-width: 100%;

          ::v-deep & .c-switcher-group {
            width: 100%;
          }

          ::v-deep & .c-switcher-group-item {
            width: 50%;
          }
        }

        &-red {
          ::v-deep & .c-switcher-group-item_active {
            background: #ffd3e8;
          }
        }

        &-green {
          ::v-deep & .c-switcher-group-item_active {
            background: #d0f4e3;
          }
        }
      }
    }

    &-row-2 {
      margin-top: 26px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      &-required {
        padding-bottom: 22px;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }

      @media screen and (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &-fine-author {
        width: calc(100% - 130px);
        max-width: calc(100% - 130px);

        @media screen and (max-width: 700px) {
          width: 100%;
          max-width: 100%;
        }

        &-required {
          @media screen and (max-width: 700px) {
            padding-bottom: 22px;
          }
        }
      }

      &-amount {
        max-width: 100px;
        width: 100%;

        &::v-deep .c-input-required-text {
          white-space: normal !important;
        }

        @media screen and (max-width: 700px) {
          margin-top: 21px;
          width: 50%;
          max-width: 50%;
        }

        &-required {
          @media screen and (max-width: 700px) {
            padding-bottom: 22px;
          }
        }
      }
    }

    &-basis-of-fine {
      margin-top: 25px;

      &-required {
        padding-bottom: 22px;
      }
    }

    &-comment {
      margin-top: 25px;
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 31px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
